import { z } from 'zod';

const requiredId = (label: string) =>
  z.coerce
    .number()
    .refine((n) => Number.isFinite(n) && n > 0, `${label} is required`);

export const resourceFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  school: requiredId('School'),
  room: requiredId('Room'),
});
